import { render, staticRenderFns } from "./EmailPartnerSelect.vue?vue&type=template&id=37b68ef4&scoped=true&"
import script from "./EmailPartnerSelect.vue?vue&type=script&lang=js&"
export * from "./EmailPartnerSelect.vue?vue&type=script&lang=js&"
import style0 from "./EmailPartnerSelect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmailPartnerSelect.vue?vue&type=style&index=1&id=37b68ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b68ef4",
  null
  
)

export default component.exports